<mat-dialog-content>
  <div class="p-4">
    <div class="fs-4 text-black mb-4 fw-bold">Edit Payment Method</div>

    <!-- Current Payment Method -->
    <div class="mb-4">
      <label class="form-label fw-semibold">Current Payment Method:</label>
      <div class="d-flex align-items-center p-3 bg-light rounded">
        <img *ngIf="currentPaymentMethod?.logoUrl" 
             [src]="currentPaymentMethod.logoUrl" 
             class="w-30px h-30px object-fit-contain rounded me-3">
        <span class="fs-5">{{ currentPaymentMethod?.name }}</span>
      </div>
    </div>

    <!-- Manager Info -->
    <div class="mb-4">
      <label class="form-label fw-semibold">Authorized By:</label>
      <div class="p-3 bg-light rounded">
        <span class="fs-6">{{ managerName }}</span>
      </div>
    </div>

    <!-- Reason/Remark -->
    <div class="mb-4">
      <label class="form-label fw-semibold">Reason (Required):</label>
      <div>
        <textarea class="form-control" 
                  [(ngModel)]="remark" 
                  rows="3"
                  placeholder="Enter reason for payment method change..."></textarea>
      </div>
    </div>

    <!-- New Payment Method Selection -->
    <div class="mb-4">
      <label class="form-label fw-semibold">Select New Payment Method:</label>
      
      <div *ngIf="isLoading" class="text-center p-4">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
        <p class="mt-2">Loading payment methods...</p>
      </div>

      <div *ngIf="!isLoading" class="payment-methods-list">
        <div *ngFor="let pm of paymentMethods" 
             class="payment-method-item p-3 mb-2 rounded border cursor-pointer"
             [class.selected]="selectedPaymentMethodId === pm.id"
             [class.current]="currentPaymentMethod?.id === pm.id"
             (click)="onPaymentMethodChange(pm.id)">
          <div class="d-flex align-items-center">
            <input type="radio" 
                   [value]="pm.id" 
                   [checked]="selectedPaymentMethodId === pm.id"
                   class="me-3">
            <img *ngIf="pm.logoUrl" 
                 [src]="pm.logoUrl" 
                 class="w-30px h-30px object-fit-contain rounded me-3">
            <span class="fs-6">{{ pm.name }}</span>
            <span *ngIf="currentPaymentMethod?.id === pm.id" 
                  class="badge bg-secondary ms-2">Current</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Reference No (Optional) -->
    <div class="mb-4" *ngIf="selectedPaymentMethodName && selectedPaymentMethodName.toLowerCase() !== 'cash'">
      <label class="form-label fw-semibold">Reference No (Optional):</label>
      <div>
        <input type="text" class="form-control p-3 rounded" 
               [(ngModel)]="referenceNo" 
               placeholder="Enter reference number (e.g. Transaction ID)">
      </div>
    </div>

    <!-- Warning Message -->
    <div *ngIf="selectedPaymentMethodId && selectedPaymentMethodId !== currentPaymentMethod?.id" 
         class="alert alert-warning mb-0">
      <i class="fa fa-exclamation-triangle me-2"></i>
      This will change the payment method and record the change in audit logs.
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="d-flex justify-content-end w-100 p-3 gap-2">
    <button class="btn btn-default border px-4 py-2" (click)="cancel()">
      <i class="fa fa-times me-2"></i>
      Cancel
    </button>
    <button class="btn btn-primary px-4 py-2" 
            (click)="save()" 
            [disabled]="!canSave()">
      <i class="fa fa-save me-2"></i>
      Save Changes
    </button>
  </div>
</mat-dialog-actions>
